/**
 * jquery validate オプション(rules,messages)　の設定
 *
 */
(function () {

  var rul = {};
  var msg = {};
  var glp = {};
  var getMsg = window.ohValidateGetMsg; //先にjs/validation/common.jsを読み込んでおく

  // メールアドレス
  // ajaxで複数のバリデーションを実装
  rul['email'] = {
    required: true,
    maxlength: 60,
    remote: "/api/validate-email-registered",
  };
  msg['email'] = {
    required:getMsg('required','メールアドレス'),
    maxlength:getMsg('max.string', 'メールアドレス', {'max' : '60'}),
    remote:getMsg('email_check','メールアドレス'),
  };

  // パスワード
  rul['passwd'] = {required: true, regex: '^[0-9a-zA-Z]+$', rangelength: [8,16]};
  msg['passwd'] = {
    required: getMsg('required', 'パスワード'),
    regex: getMsg('alpha_num2', 'パスワード' ),
    rangelength: getMsg('between.string', 'パスワード', {'min': '8', 'max': '16'}),
  };

  // パスワード確認
  rul['passwd_confirm'] = {equalTo: '#passwd'};
  msg['passwd_confirm'] = {
    equalTo: getMsg('compare2','新しいパスワード'),
  };

  // 希望地域
  rul['cond_area_setting_kbn[]'] = {required: true,};
  msg['cond_area_setting_kbn[]'] = {
    required:getMsg('required','希望地域'),
  };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = glp;

}());

/**
 * jquery validate バリデーション実行タイミングの設定
 *
 */
(function () {
}());
